import { API } from "services/api";
import type { RelatorioPagamentosPayload } from "./relatorio.types";

export const postRelatorioPagamentosCsv = async (
  payload: RelatorioPagamentosPayload,
): Promise<Blob> => {
  const response = await API.post("/api/relatorio/pagamentos.csv", payload, {
    responseType: "blob",
  });

  return response.data;
};
